import { render, staticRenderFns } from "./Donut.vue?vue&type=template&id=7518d5e4&"
import script from "./Donut.vue?vue&type=script&lang=ts&"
export * from "./Donut.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports